// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"finished_fieldset__28Aub","legend":"finished_legend__2H0sS"};